import apiCall from "./apiCall";

export type ExchangeRate = {
    date: string,
    value: number,
};

const getExchangeRate = async (params: any) => {
    const URL = `/Global/exchange-rate?mts=${params.mts}&date=${params.date}`;
    return apiCall('get', URL);
};

const getExchangeRateDateRange = async (startDate: string, endDate: string, pageNumber: number, pageSize: number) => {
    const URL = `/JisdorData/GetListJisdorData?startDate=${startDate}&endDate=${endDate}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
    return apiCall('get', URL);
};

const getExchangeRateLast7DaysAverage = async (lastDate: string /* YYYY-MM-DD */) => {
    const URL = `/JisdorData/GetAverageKursSavenDaysFromDate?date=${lastDate}`;
    return apiCall('get', URL);
};

const getExchangeRateMonthlyAverage = async (month: number, year: number) => {
    const URL = `/JisdorData/GetAverageKursByMonth?month=${month}&year=${year}`;
    return apiCall('get', URL);
};

const getLatestExchangeRateFromJisdor = async () => {
    const URL = `/Global/GetJisdorDataByDateRangeNoParam`;
    return apiCall('get', URL);
};

export {
    getExchangeRate,
    getExchangeRateDateRange,
    getExchangeRateLast7DaysAverage,
    getExchangeRateMonthlyAverage,
    getLatestExchangeRateFromJisdor,
};
